// import { useGetPreventaById, useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useCheckPermissions } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import SavePreventaCorporativa from "../../shared/save_preventa_coperativo/SavePreventaCorporativa";
// import { useGetProspectoByIdProspectoCorporativo } from "@/shared/actions/erp/prospecto_corporativo.actions";
import { fetchGetByIdPreventasCorporativos } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";

///* Solo supervisor puede editar una preventa

export default function CompletarPreventaCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_change_preventa);

  const { idpreventa } = useParams();

  // const { data, isLoading } = useGetProspectoByIdProspectoCorporativo(idprospecto!);

  const { data: dataPreventaCorporativa, isLoading: isLoadingPreventaCorporativa } = fetchGetByIdPreventasCorporativos(idpreventa!)

  if (isLoadingPreventaCorporativa) return <LoaderComponent />

  if (!dataPreventaCorporativa) return null;

  return (
    <SavePreventaCorporativa
      title="Oportunidad Comercial Aprobada"
      dataProspecto={dataPreventaCorporativa?.data?.prospecto_corporativo_data!}
      dataPreventaCorporativa={dataPreventaCorporativa?.data}
      enableEdit={true}
    />
  );

}